import { Markdown } from '@ibsys/kit';
import { FC } from 'react';
import type { CustomChartTextSummaryPayload } from '@/entities/dashboards';
import { ChartCardShell } from '../ChartCardShell';

type Props = {
  title: string;
  payload: CustomChartTextSummaryPayload;
};

/** Текстовая сводка: связный текст, составленный по отобранным правилом агрегатам. */
export const TextSummaryChartView: FC<Props> = ({ title, payload }) => (
  <ChartCardShell title={title}>
    <Markdown className="w-full">{payload.markdown}</Markdown>
  </ChartCardShell>
);
